import React from 'react'

const ReelsLinkCarousel = ({ card, onLoaded }) => {
  if (!card?.media?.url) return null

  const isVideo = card.media.url.endsWith('.mp4') || card.media.type === 'video'

  if (isVideo) {
    return (
      <div className="reel__background">
        <video
          className="reel__video"
          src={card.media.url}
          autoPlay
          loop
          muted
          playsInline
          onLoadedData={onLoaded}
        />
      </div>
    )
  }

  return (
    <div
      className="reel__background"
      style={{ backgroundImage: `url(${card.media.url})` }}
    />
  )
}

export default ReelsLinkCarousel
